import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingFeeCondition} from './pricing-fee-condition';

@JsonObject('model.PricingFee')
export class PricingFee extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(Number, 'basePrice')
  basePrice?: number

  @JsonProperty(Boolean, 'forFirstArea')
  forFirstArea?: boolean

  @JsonProperty(String, 'type')
  type?: string

  @JsonProperty(String, 'anchor')
  anchor?: string

  @JsonProperty([PricingFeeCondition], 'conditions')
  conditions?: PricingFeeCondition[] = []
}

